import styled from 'styled-components';

import { PORCELAIN, SANTAS_GRAY } from '@/constants/colors';

export const SRFundsPaymentFormStyled = styled.div`
  position: relative;

  .balance-wrap {
    display: flex;
  }

  .balance {
    background: ${PORCELAIN};
    border-radius: 8px;
    padding: 16px 20px;
  }

  .balance__title {
    color: ${SANTAS_GRAY};
    text-transform: uppercase;
  }

  .balance-price {
    margin-top: 8px;

    display: flex;
    align-items: flex-end;
  }

  .balance-price__amount {
    font-weight: 600;
    font-size: 3.2rem;
    line-height: 3.8rem;
  }

  .balance-price__funds-btn {
    padding: 1rem;
    font-size: 1.6rem;
    line-height: 1.6rem;
    text-transform: uppercase;
  }

  .purchase-btn {
    margin-top: 20px;

    min-width: 200px;
  }
`;

export default SRFundsPaymentFormStyled;
